<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/7foreword#foreword">Foreword</a></p>
<p class="toc1"><a href="#/8chap1#chap1">Introduction</a></p>
<p class="toc1"><a href="#/9chap2#chap2">Epigraph</a></p>
<p class="toc1"><a href="#/10chap3#chap3">The Impostor: 1</a></p>
<p class="toc1"><span href="#/11chap4#chap4" title="Link target outside of Sample">Big Gobi: 2</span></p>
<p class="toc1"><span href="#/12chap5#chap5" title="Link target outside of Sample">Father Lameraux: 3</span></p>
<p class="toc1"><span href="#/13chap6#chap6" title="Link target outside of Sample">Mama: 4</span></p>
<p class="toc1"><span href="#/14chap7#chap7" title="Link target outside of Sample">Kikuchi-Lotmann: 5</span></p>
<p class="toc1"><span href="#/15chap8#chap8" title="Link target outside of Sample">The Policeman: 6</span></p>
<p class="toc1"><span href="#/16chap9#chap9" title="Link target outside of Sample">Himself, Herself: 7</span></p>
<p class="toc1"><span href="#/17chap10#chap10" title="Link target outside of Sample">Nichiren: 8</span></p>
<p class="toc1"><span href="#/18chap11#chap11" title="Link target outside of Sample">An Editorial Relationship</span></p>
<p class="toc1"><span href="#/19biography#biography" title="Link target outside of Sample">A Biography of Edward Whittemore</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5TOC.vue?4f832baa